<template>
  <div class="section-main__warp personMg-page">
    <div class="left-content">
      <listDataManage @queryTable="queryTable" />
    </div>
    <div class="right-content">
      <div class="query">
        <el-form
          :inline="true"
          style="margin-top: 10px; transition: all 200ms"
          :class="showSearch ? 'expand searchContent' : 'up searchContent'"
          :model="queryForm"
          ref="form"
        >
          <el-form-item prop="credentialType" label="证件类型">
            <el-select v-model="queryForm.credentialType" placeholder="请选择证件类型">
              <el-option
                v-for="item in IDNoType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件号" prop="credentialNumber">
            <el-input
              clearable
              v-model="queryForm.credentialNumber"
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input
              clearable
              v-model="queryForm.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" @click="getTable">查询</el-button>
          <el-button type="info" size="small" @click="resetList"> 重置 </el-button>
          <el-button
            type="text"
            size="medium"
            v-show="showExpandBtn"
            style="color: #407aee"
            @click="showSearch = !showSearch"
            :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
            >{{ !showSearch ? "展开" : "收起" }}</el-button
          >
        </div>
        <!-- </el-collapse-transition> -->
      </div>
      <div class="content">
        <div style="height: calc(100% - 45px)">
          <div style="padding-left: 16px">
            <el-checkbox
              v-model="checkedAll"
              v-if="peopleList && peopleList.length"
              v-auth="'/personMg:deleteList'"
              :indeterminate="isIndeterminate"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <el-button type="info" style="margin: 0 22px" @click="handleAdd"
              >创建名单</el-button
            >
            <el-button
              type="info"
              size="small"
              :disabled="!listCodes.length"
              @click="handleDeLAll"
            >
              删除
            </el-button>
          </div>

          <div class="list">
            <el-scrollbar style="height: 100%; width: 100%">
              <el-checkbox-group
                style="width: 100%; display: flex; flex-wrap: wrap; height: 100%"
                v-model="listNames"
                @change="handleCheckedPeople"
              >
                <div class="list-item" v-for="item in peopleList" :key="item.code">
                  <div class="item-btn">
                    <div>
                      <el-checkbox
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                        @change="
                          (value) => {
                            handleItemCheck(value, item);
                          }
                        "
                      ></el-checkbox>
                    </div>
                    <div>
                      <!-- <img
                        src="../style/point.png"
                        alt=""
                        title="查看轨迹"
                        @click="handlePoint(item)"
                        style="width: 14px; height: 14px; margin: 0 5px; cursor: pointer"
                      /> -->
                      <i
                        class="el-icon-delete"
                        title="删除"
                        @click="handleDel(item)"
                        style="cursor: pointer"
                      ></i>
                    </div>
                  </div>
                  <div
                    style="width: 100%; height: calc(100% - 30px)"
                    @click="handleUpdate(item)"
                  >
                    <img
                      :src="imgPath(item)"
                      alt=""
                      style="object-fit: fill; width: 100%; height: 100%; cursor: pointer"
                    />
                  </div>
                  <div class="itemInfo">
                    <div><span> 姓名 </span> {{ item.name }}</div>
                    <div>
                      <span> 性别 </span>
                      {{ item.sex == 0 ? "女" : item.sex == 1 ? "男" : "" }}
                    </div>
                    <div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'证件号码:' + (item.credentialNumber || '无')"
                        placement="top"
                      >
                        <span>
                          证件号码 &nbsp;&nbsp;&nbsp;{{ item.credentialNumber || "无" }}
                        </span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
          </div>
        </div>

        <div class="pagination" v-if="page.total">
          <el-pagination
            class="mt10 mb10"
            background
            :layout="page.layout || 'total, sizes, prev, pager, next, jumper'"
            :page-size="page.pageSize"
            :total="page.total"
            :pager-count="page.countPage || 7"
            :current-page="page.pageNum"
            @size-change="sizeChange"
            @current-change="pageChange"
            @prev-click="pageChange"
            @next-click="pageChange"
          />
        </div>
      </div>
    </div>
    <app-panel
      class="app-panel"
      :isExpand="showAppPanel"
      @cancel="handleClosePanel"
      :title="formState == 1 ? '新增人员名单' : '修改人员名单'"
    >
      <div>
        <el-form
          style="height: 99%; position: absolute; width: 100%"
          :inline="true"
          :model="peopleForm"
          :rules="rules"
          ref="refForm"
          label-width="105px"
          label-position="right"
          label-suffix=" ："
        >
          <el-scrollbar style="height: 100%">
            <div style="display: flex">
              <div style="width: 70%">
                <el-col :span="12">
                  <el-form-item label="名单分类" prop="personType">
                    {{ Number(groupInfo.type) | dic("SENU027") }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="名单名称" prop="personType">
                    {{ groupInfo.name }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="姓名" prop="name">
                    <el-input
                      clearable
                      v-model="peopleForm.name"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="性别" prop="sex">
                    <el-select
                      v-model="peopleForm.sex"
                      style="width: 100%"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in sexType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="手机号码" prop="phone">
                    <el-input
                      clearable
                      v-model="peopleForm.phone"
                      placeholder="请输入手机号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div style="">
                <el-form-item label="" prop="fileCode">
                  <el-col :span="24">
                    <el-upload
                      action
                      v-if="!fileList.length"
                      :file-list="fileList"
                      ref="accountUpload"
                      :show-file-list="false"
                      :list-type="'picture-card'"
                      accept="image/png, image/jpg, image/jpeg, image/bpm"
                      :auto-upload="false"
                      :multiple="false"
                      :limit="1"
                      :on-change="onChangeFile"
                      :on-remove="onRemoveFile"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="imgFile" v-else>
                      <img
                        :src="imageUrl"
                        :class="formState == 'view' ? 'viewImg' : 'uploadImg'"
                        onerror="this.src='/images/theme/newDark/default.png'"
                      />
                      <div class="delete-icon" v-if="formState != 'view'">
                        <i class="el-icon-delete" @click="onRemoveFile"></i>
                      </div>
                    </div>
                  </el-col>
                </el-form-item>
              </div>
            </div>
            <el-col :span="24">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  style="width: 100%"
                  v-model="peopleForm.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="证件类型" prop="credentialType">
                <el-select
                  v-model="peopleForm.credentialType"
                  style="width: 100%"
                  placeholder="请选择证件类型"
                >
                  <el-option
                    v-for="item in IDNoType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="证件号码" prop="credentialNumber">
                <el-input
                  clearable
                  :maxlength="18"
                  v-model="peopleForm.credentialNumber"
                  placeholder="请输入证件号码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="布控原因" prop="desc">
                <el-input
                  maxlength="200"
                  show-word-limit
                  clearable
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="peopleForm.desc"
                  placeholder="请输入布控原因"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-scrollbar>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleClosePanel" :loading="btnLoading">
          {{ btnLoading ? "提交中" : "取消" }}</el-button
        >
        <el-button type="primary" @click="handleSavePanel" :loading="btnLoading">{{
          btnLoading ? "提交中" : "保存"
        }}</el-button>
      </span>
    </app-panel>
    <dialog-map ref="dialogMap"></dialog-map>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Bus, Dates } from "$utils";
import dialogMap from "@src/components/common/app-dialog/dialog-mapNew";
import listDataManage from "../components/listDataManage.vue";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  name: "personMg",
  components: { listDataManage, appPanel, dialogMap },
  data() {
    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value) && value) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    return {
      showSearch: false,
      fileList: [],
      imageUrl: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        // credentialType: [
        //   {
        //     required: true,
        //     message: "请选择证件类型",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // credentialNumber: [
        //   {
        //     required: true,
        //     message: "请输入证件号码",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // birthday: [
        //   {
        //     required: true,
        //     message: "请选择出生日期",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        fileCode: [
          {
            required: true,
            message: "请上传图片",
            trigger: ["change"],
          },
        ],
        phone: [
          {
            required: false,
            trigger: ["change"],
            validator: validatePhone,
          },
        ],
      },
      peopleForm: {
        name: "",
        sex: "",
        birthday: "",
        credentialType: 5,
        credentialNumber:
          "Q" + utils.Base.randomLenNum(6) + Date.now().toString().slice(0, 4) + "T",
        fileCode: "",
        phone: "",
      },
      showAppPanel: false,
      btnLoading: false,
      formState: 1,
      sexType: Dic.find("SENU018"),
      IDNoType: Dic.find("SENU028"),
      groupType: Dic.find("SENU027"),
      queryForm: {
        credentialType: "",
        credentialNumber: "",
        name: "",
      },
      groupInfo: {},
      peopleList: [],
      listNames: [],
      listCodes: [],
      page: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
      },
      checkedAll: false,
      isIndeterminate: false,
      viewerPhotos: [],
      showExpandBtn: false,
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  mounted() {
    this.animation();
  },
  methods: {
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        this.showExpandBtn = true;
      } else {
        this.showExpandBtn = false;
      }
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    onChangeFile(file, fileList) {
      if (!this.validImg(file)) {
        this.imageUrl = "";
        this.fileList = [];
        return false;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      this.fileList = fileList;
      this.peopleForm.fileCode = "add";
      this.$nextTick(() => {
        this.$refs.refForm.clearValidate("fileCode");
      });
    },
    onRemoveFile(file, fileList) {
      this.$confirm("确认要删除图片吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.imageUrl = "";
        this.fileList = [];
        this.peopleForm.fileCode = "";
      });
    },
    handleClosePanel() {
      this.fileList = [];
      this.imageUrl = "";
      this.$refs.refForm.resetFields();
      this.peopleForm = { ...this.$options.data().peopleForm };
      console.log(this.peopleForm);
      this.showAppPanel = false;
    },
    handleSavePanel() {
      console.log(this.peopleForm);
      this.$refs.refForm.validate((res) => {
        if (res) {
          let params = { ...this.peopleForm };
          if (
            (!this.peopleForm.fileCode || this.peopleForm.fileCode == "add") &&
            this.fileList.length
          ) {
            let formData = new FormData();
            this.fileList.map((item) => {
              formData.append("files", item.raw);
            });
            this.$fetch(api.batchFileload, formData).then((res) => {
              params.fileCode = res.returnObj[0].fileId;
              this.handleSubmit(params);
            });
          } else {
            this.handleSubmit(params);
          }
        }
      });
    },
    handleSubmit(params) {
      let url = !params.code ? api.addPersonnelBwlist : api.updatePersonnelBwlist;
      params.repositorCode = this.groupInfo.code;
      params.attachments = [
        {
          fileCode: params.fileCode,
        },
      ];
      console.log(params);
      this.btnLoading = true;
      this.$fetch(url, params).then((res) => {
        this.btnLoading = false;
        if (res.success) {
          this.getTable();
          this.$message.success(
            this.formState === 1
              ? this.$t("personMg.title.addOk")
              : this.$t("personMg.title.editOk")
          );
          this.handleClosePanel();
        } else {
          this.$message.error(res.msgContent || "操作失败");
        }
      });
    },
    handlePoint(info) {
      this.$refs.dialogMap.openMap(info);
    },
    handleUpdate(info) {
      // console.log(info);
      this.formState = 2;
      this.showAppPanel = true;
      this.peopleForm = { ...info };
      if (this.peopleForm.sex) {
        this.peopleForm.sex = Number(info.sex);
      }
      this.imageUrl = utils.Bus.imgPath(this.peopleForm.fileCode);
      this.fileList.push({
        url: this.imageUrl,
        status: "update",
        fileCode: this.peopleForm.fileCode,
      });
      this.$refs.refForm.clearValidate("fileCode");
      // console.log(this.peopleForm);
    },
    handleAdd() {
      this.formState = 1;
      this.showAppPanel = true;
    },
    handleDeLAll() {
      if (this.listCodes.length === 0) {
        this.$message.warning(this.$t("personMg.message.delete"));
      } else {
        this.$confirm(this.$t("personMg.message.selectDel"), "删除确认", {
          confirmButtonText: this.$t("personMg.button.confirm"),
          cancelButtonText: this.$t("personMg.button.cancel"),
          type: "warning",
        }).then((res) => {
          this.$fetch(api.deletePersonnelBwlist, {
            repositorCode: this.groupInfo.code,
            codes: this.listCodes,
          }).then((res) => {
            if (res.success) {
              this.$message.success(this.$t("personMg.message.successDel"));
              this.listCodes = [];
              this.checkedAll = false;
              this.getTable();
            } else {
              this.$message.error(this.$t("personMg.message.failDel") + res.msgContent);
            }
          });
        });
      }
    },
    // 删除单个名单
    handleDel(data) {
      this.$confirm(this.$t("personMg.message.targetDel"), "删除确认", {
        confirmButtonText: this.$t("personMg.button.confirm"),
        cancelButtonText: this.$t("personMg.button.cancel"),
        type: "warning",
      }).then(() => {
        this.$fetch(api.deletePersonnelBwlist, {
          repositorCode: this.groupInfo.code,
          codes: [data.code],
        }).then((res) => {
          if (res.success) {
            this.isIndeterminate = false;
            this.$message.success(this.$t("personMg.message.successDel"));
            this.getTable();
          } else {
            this.$message.error(this.$t("personMg.message.failDel") + res.msgContent);
          }
        });
      });
    },
    // 全选
    handleCheckAllChange(val) {
      if (val) {
        this.listNames = this.peopleList.map((item) => {
          return item.name;
        });
        this.listCodes = this.peopleList.map((item) => {
          return item.code;
        });
      } else {
        this.isIndeterminate = false;
        this.listNames = [];
      }
    },
    // 单个复选框事件
    handleItemCheck(val, info) {
      if (val) {
        this.listCodes.push(info.code);
      } else {
        this.listCodes.splice(this.listCodes.indexOf(info.code, 1));
      }
      console.log(this.listCodes);
    },
    // 复选框组选中事件
    handleCheckedPeople(value) {
      let checkedCount = value.length;
      this.checkedAll = checkedCount == this.peopleList.length ? true : false;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.peopleList.length;
    },
    showViewer(e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    imgPath(item) {
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    queryTable(peopleForm) {
      console.log("名单数据", peopleForm);
      this.groupInfo = peopleForm;
      this.getTable();
    },
    getTable() {
      let params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        repositorCode: this.groupInfo.code,
      };
      this.$fetch(api.queryPersonnelBwlist, Object.assign(params, this.queryForm)).then(
        (res) => {
          if (res.success) {
            this.peopleList = res.returnObj.list;
            this.page.total = res.returnObj.total;
          } else {
            this.peopleList = [];
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    resetList() {
      this.$refs.form.resetFields();
      this.getTable();
    },
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getTable();
    },
    pageChange(val) {
      this.page.pageNum = val;
      this.getTable();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

:deep .el-scrollbar__view {
  height: 100%;
}

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.app-panel {
  z-index: 2;

  :deep .el-upload--picture-card {
    width: 85%;
    margin: 5px 0px 0;
    height: 180px;
    line-height: 180px;
  }

  .el-form-item {
    width: 100%;
    display: flex;

    :deep .el-form-item__content {
      width: calc(100% - 125px);
    }

    :deep .el-upload--picture-card {
      width: 180px;
      height: 180px;
    }

    .el-input__inner {
      width: 100%;
    }
  }

  .imgFile {
    height: 180px;
    width: 180px;
    position: relative;

    .viewImg {
      width: 175px;
      height: 175px;
      object-fit: cover;
    }

    .uploadImg {
      width: 180px;
      height: 180px;
      object-fit: cover;
      cursor: pointer;
    }

    &:hover {
      .delete-icon {
        opacity: 1;
      }
    }

    .delete-icon {
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 1px;
      left: 0;
      width: 180px;
      height: 180px;
      border-radius: 6px;
      opacity: 0;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0.4);
      transition: all 0.2s;
      box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
    }
  }
}

.personMg-page {
  width: 100%;

  .left-content {
    width: 280px;
    padding: 10px 16px;
    @include set_theme_color(background-color, left-menu-bg-color);
    // background: #181f2e;
  }

  .right-content {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    flex: 1;

    .query {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include set_theme_color(background-color, left-menu-bg-color);
      padding: 10px 16px 3px;

      .el-form-item {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 8px !important;
        vertical-align: top;
      }
    }

    .content {
      flex: 1;
      height: 85%;
      margin-top: 10px;
      padding: 20px 0px;
      @include set_theme_color(background-color, left-menu-bg-color);
    }

    .list {
      margin-top: 20px;
      height: calc(100% - 65px);
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      //   justify-content: space-between;
    }

    .list-item {
      //   min-height: 240px;
      min-width: 160px;
      width: calc((100% - 150px) / 5);
      height: 44%;
      margin: 0 15px 20px;
      position: relative;

      .item-btn {
        font-size: 13px;
        height: 30px;
        @include set_theme_color(background-color, page-default-bg);
        padding: 7px 10px;
        display: flex;
        justify-content: space-between;
      }

      .itemInfo {
        color: #fff;
        width: 100%;
        padding: 0px 8px;
        position: absolute;
        bottom: 0;
        background-image: url("../style/bg.png");
        background-size: cover;
        font-size: 8px;

        div {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        span {
          width: 50px;
          display: inline-block;
          text-align: right;
          margin: 4px 10px 4px 0;
        }
      }
    }

    .pagination {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
